import { CreateFileRequestContent, CreateFileResponseContent } from "@equaliq/api-model";
import { createApiRequest } from "../common";

/**
 * API function to create a new file record
 * @param request File creation parameters
 * @returns Promise with created file and optional upload URL
 */
export const createFileApi = async (request: CreateFileRequestContent): Promise<CreateFileResponseContent> => {
  const apiRequest = createApiRequest<CreateFileResponseContent>('post', '/files/create');
  return apiRequest(request);
};
